/* eslint-disable react/jsx-one-expression-per-line */
import { Box, Center, Flex, Icon, Spinner, Text, VStack } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaRegLightbulb } from 'react-icons/fa';
import { FiFileText } from 'react-icons/fi';
import { CreateTemplateButton } from '../modal/components/CreateTemplateButton';

export type QuestionnaireTemplateEmptyViewProps = {
  isFetching?: boolean;
};

export const QuestionnaireTemplateEmptyView = ({ isFetching }: QuestionnaireTemplateEmptyViewProps) => {
  const { t } = useTranslation('administration');
  return (
    <Box bg="white" w="100%" minH="calc(100vh - 64px - 4rem)" p={6} borderRadius={6} position="relative">
      <Flex align="center" justify="space-between" gap={4} mb={3}>
        <Text as="span" fontWeight="600">
          {t('questionnaireTemplate.title')}
        </Text>
      </Flex>

      <Box borderRadius="2xl" mb={8} p={3} bg="blue.50">
        <Flex align="flex-start" gap={3}>
          <FaRegLightbulb fontSize={24} />
          <Text fontSize="sm" color="gray.700" paddingLeft={2}>
            <Text as="span" fontWeight="600">
              {t('questionnaireTemplate.emptyTemplateText1')}
            </Text>{' '}
            {t('questionnaireTemplate.emptyTemplateText2')}
          </Text>
        </Flex>
      </Box>
      <Center py={20}>
        <VStack spacing={4}>
          <Center w="44px" h="44px" borderRadius="full" bg="blue.50">
            <Icon as={FiFileText} color="blue.500" boxSize="18px" />
          </Center>

          <Text fontSize="sm" color="gray.600">
            {t('questionnaireTemplate.createTemplateText')}
          </Text>

          <CreateTemplateButton />
        </VStack>
      </Center>
      {isFetching && (
        <Center position="absolute" top="0" left="0" right="0" bottom="0" bg="rgba(255,255,255,0.6)" zIndex={1}>
          <Spinner colorScheme="blue" size="lg" />
        </Center>
      )}
    </Box>
  );
};
